import { useEffect, useState } from 'react';
import styles from './exclusiveContent.module.css';

export function useExclusiveView(ref, mode = 'display') {
  const [isEnable, setEnable] = useState(false);

  useEffect(() => {
    const instance = ref.current;
    instance.classList.toggle(styles.exclusiveContent, isEnable);
    instance.dataset.collapseMode = mode;

    return () => {
      instance.classList.toggle(styles.exclusiveContent, false);
      delete instance.dataset.collapseMode;
    };
  }, [isEnable, ref, mode]);

  return setEnable;
}
